import { useTheme } from '@mui/material';
import type { SVGProps } from 'react';

export const LifebuoyIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.84829 5.84797L9.2424 9.24209M14.7578 9.24209L18.1519 5.84797M5.84829 18.1516L9.2424 14.7575M14.7578 14.7575L18.1519 18.1516M20.7 11.9998C20.7 7.19493 16.8049 3.2998 12 3.2998C7.19517 3.2998 3.30005 7.19493 3.30005 11.9998C3.30005 16.8047 7.19517 20.6998 12 20.6998C16.8049 20.6998 20.7 16.8047 20.7 11.9998ZM15.9 11.9998C15.9 9.84589 14.154 8.0998 12 8.0998C9.84614 8.0998 8.10005 9.84589 8.10005 11.9998C8.10005 14.1537 9.84614 15.8998 12 15.8998C14.154 15.8998 15.9 14.1537 15.9 11.9998Z"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </svg>
  );
};
